module.exports = __webpack_public_path__ + "img/DTYLX_Ita.17a90ccf.png";